<template>
  <div v-loading.fullscreen.lock="loading">
    <base-header class="pb-6 px-4">
      <div class="row align-items-center py-2">
        <div class="col-lg-6 col-7"></div>
      </div>
    </base-header>
    <div class="content">
      <div class="mt--6 px-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="card-wrapper">
              <!-- Input groups -->
              <card  class="form-style">
                <template slot="header">
                  <div style="display: flex; flex-direction: column; gap: 10px; align-items: center; margin-bottom: 20px;">
                    <img class="logo-size" src="/signup-img/hot-logo.webp"  alt="">
                    <h4 class="mb-2">Secure Payment Information</h4>
                    <div class="payment-radio-btn">
                      <label class="mr-2"><strong>Selected Payment Method : </strong></label>
                      <input type="radio" value="credit_card" v-model="paymentMethod" /> Credit Card
                      <input type="radio" value="ach" v-model="paymentMethod" class="ml-3" /> ACH
                    </div>
                  </div>
                </template>
                <!-- Card header -->
                <div class="row mb-0 mb-md-2" v-if="paymentMethod === 'ach'">

                  <div class="col-md-6">
                    <label class="form-control-label">
                      Account Holder Name <span class="requireField">*</span>
                    </label>
                    <base-input name="Account Holder Name" placeholder="Account Holder Name" rules="required"
                      v-model="ach.acc_name" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-control-label">
                      Transit/ABA Routing Number <span class="requireField">*</span>
                    </label>
                    <base-input name="Routing Number" placeholder="Routing Number" rules="required"
                      v-model="ach.routing_number" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-control-label">
                      Account Number <span class="requireField">*</span>
                    </label>
                    <base-input name="Account Number" placeholder="Account Number" rules="required"
                      v-model="ach.account_number" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-control-label">
                      Financial Institution (Bank Name) <span class="requireField">*</span>
                    </label>
                    <base-input name="Financial Institution" placeholder="Financial Institution" rules="required"
                      v-model="ach.financial_institution" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-control-label">
                      Address <span class="requireField">*</span>
                    </label>
                    <base-input name="Address" placeholder="Address" rules="required" v-model="ach.address" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-control-label">
                      City <span class="requireField">*</span>
                    </label>
                    <base-input name="City" placeholder="City" rules="required" v-model="ach.city" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-control-label">
                      State <span class="requireField">*</span>
                    </label>
                    <base-input name="State" placeholder="State" rules="required" v-model="ach.state" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-control-label">
                      Zip <span class="requireField">*</span>
                    </label>
                    <base-input name="Zip Code" placeholder="Zip Code" rules="required" v-model="ach.zip" />
                  </div>

                  <div class="col-md-12">
                    <label class="form-control-label">
                      Branch <span class="requireField">*</span>
                    </label>
                    <base-input name="Branch" placeholder="Branch" rules="required" v-model="ach.branch" />
                  </div>

                </div>
                <!-- Credit Card Form -->
                <div v-if="paymentMethod === 'credit_card'" class="row">
                  <div class="col-md-6">
                    <label class="form-control-label">Name on Credit Card <span class="requireField">*</span></label>
                    <base-input name="Name on Card" placeholder="Name on Card" rules="required"
                      v-model="creditCard.name_on_card" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-control-label">Billing Address <span class="requireField">*</span></label>
                    <base-input name="Billing Address" placeholder="Billing Address" rules="required"
                      v-model="creditCard.billing_address" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Company Name <span class="requireField">*</span></label>
                    <base-input name="Company Name " placeholder="Company Name" rules="required"
                      v-model="creditCard.company_name" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Location Address/Store #  <span class="requireField">*</span></label>
                    <base-input name="Location Address/Store # " placeholder="Location Address/Store # " rules="required"
                      v-model="creditCard.location_address" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-control-label">City <span class="requireField">*</span></label>
                    <base-input name="City" placeholder="City" rules="required" v-model="creditCard.city" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-control-label">State <span class="requireField">*</span></label>
                    <base-input name="State" placeholder="State" rules="required" v-model="creditCard.state" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-control-label">Zip Code <span class="requireField">*</span></label>
                    <base-input name="Zip Code" placeholder="Zip Code" rules="required" v-model="creditCard.zip" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-control-label">Email Address <span class="requireField">*</span></label>
                    <base-input name="Email" placeholder="Email" rules="required|email" v-model="creditCard.email" />
                  </div>

                    <div class="col-md-12">
                    <label class="form-control-label">Card Type <span class="requireField">*</span></label>
                    <div class="row">
                      <div class="col-6 col-sm-auto">
                      <label><input type="radio" value="Visa" v-model="creditCard.card_types" /> Visa</label>
                      </div>
                      <div class="col-6 col-sm-auto">
                      <label><input type="radio" value="MasterCard" v-model="creditCard.card_types" /> MasterCard</label>
                      </div>
                      <div class="col-6 col-sm-auto">
                      <label><input type="radio" value="AmEx" v-model="creditCard.card_types" /> Am Ex</label>
                      </div>
                      <div class="col-6 col-sm-auto">
                      <label><input type="radio" value="Discover" v-model="creditCard.card_types" /> Discover</label>
                      </div>
                      <div class="col-6 col-sm-auto">
                      <label><input type="radio" value="Other" v-model="creditCard.card_types" /> Other</label>
                      </div>
                    </div>
                    </div>

                  <div class="col-md-8">
                    <label class="form-control-label">Card Number <span class="requireField">*</span></label>
                    <base-input name="Card Number" placeholder="Card Number"
                      rules="required"
                      v-model="creditCard.card_number"

                      />
                  </div>

                  <div class="col-md-2">
                    <label class="form-control-label">Expiration Date <span class="requireField">*</span></label>
                    <base-input name="Expiration Date" placeholder="MM/YY" rules="required" v-model="creditCard.expiry" />
                  </div>

                  <div class="col-md-2">
                    <label class="form-control-label">Security Code <span class="requireField">*</span></label>
                    <base-input name="Security Code" placeholder="CVV" rules="required"
                      v-model="creditCard.security_code" />
                  </div>
                </div>
                <div class="d-flex justify-content-between justify-content-sm-end py-2">
                  <base-button type="primary" class="font-weight-normal px-4" @click.prevent="sendAccountsEmail()"
                    native-type="submit">Submit</base-button>
                </div>




              </card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, DatePicker } from "element-ui";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import FileInput from "@/components/Inputs/FileInput";

export default {
  name: "form-components",
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      ach: {
        acc_name: '',               // Account Holder Name
        routing_number: '',         // Transit/ABA Routing Number
        account_number: '',         // Account Number
        financial_institution: '',  // Financial Institution
        address: '',                // Address
        city: '',                   // City
        state: '',                  // State
        zip: '',                    // Zip Code
        branch: '',                 // Branch
      },
      paymentMethod: 'credit_card', // default view

      creditCard: {
        name_on_card: '',
        billing_address: '',
        city: '',
        state: '',
        zip: '',
        email: '',
        card_types: [],         // multiple options possible
        card_number: '',
        expiry: '',
        security_code: '',
        company_name: '',       // Company Name
        location_address: ''    // Location Address/Store #
      },
      loading: false,
      editor: "",
      updateCardInfoModal: false,
      validated: false,
      baseUrl: this.$baseUrl,
      complete: false,
      image: "",
      files: [],
      company_id: "",
      company_name: "",
      user_id: "",
      admin_id: "",
      pickerOptions1: {
        shortcuts: []
      }
    };
  },
  created: function () {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }

    if (localStorage.getItem("hot-user") === "employee") {
      this.editor = "employee";
    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.editor = "super-admin";
      this.admin_id = localStorage.getItem("hot-user-id");
    } else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.editor = "sub-admin";
      this.user_id = localStorage.getItem("hot-user-id");
    } else if (localStorage.getItem("hot-user") === "company-admin") {
      this.editor = "company";
      this.user_id = localStorage.getItem("hot-admin-id");
      this.company_id = localStorage.getItem("hot-user-id");
      this.companyName = localStorage.getItem("hot-company-name");
    } else if (localStorage.getItem("hot-user") === "manager") {
      this.editor = "manager";
      this.user_id = localStorage.getItem("hot-user-id");
    }

    // Remove redirect path from localStorage
    if (localStorage.getItem("redirect-path")) {
      localStorage.removeItem("redirect-path");
    }
  },
    watch: {
    'creditCard.card_number'(newVal) {
      // Remove all non-digits
      let numbers = newVal.replace(/\D/g, '');

      // Limit to 16 digits
      numbers = numbers.slice(0, 16);

      // Format with space after every 4 digits
      const formatted = numbers.replace(/(.{4})/g, '$1 ').trim();

      // Avoid infinite loop
      if (formatted !== newVal) {
        this.creditCard.card_number = formatted;
      }
    }
    },
  methods: {
    cardNumberRule(value) {
      const numbers = value.replace(/\D/g, '');
      return numbers.length === 16 || 'Card number must be 16 digits';
    },
    sendAccountsEmail() {
      if (this.paymentMethod === 'ach') {
        const ach = this.ach;

        if (
          !ach.acc_name ||
          !ach.routing_number ||
          !ach.account_number ||
          !ach.financial_institution ||
          !ach.address ||
          !ach.city ||
          !ach.state ||
          !ach.zip ||
          !ach.branch
        ) {
          Swal.fire({
            title: "Missing Fields",
            text: "Please fill all required ACH fields.",
            icon: "error",
            confirmButtonText: "Ok"
          });
          return;
        }

        this.$http.post("sendMailToAccounts", {
          type: "ach",
          data: {
            acc_name: ach.acc_name,
            routing_number: ach.routing_number,
            account_number: ach.account_number,
            financial_institution: ach.financial_institution,
            address: ach.address,
            city: ach.city,
            state: ach.state,
            zip: ach.zip,
            branch: ach.branch
          }
        })
          .then(() => {
            Swal.fire({
              title: "ACH Info",
              text: "Submitted successfully.",
              icon: "success",
              confirmButtonText: "Ok"
            });
            // this.$router.push('/dashboard');
          })
          .catch(() => {
            Swal.fire({
              title: "Submission Failed",
              text: "Could not send ACH info.",
              icon: "error",
              confirmButtonText: "Ok"
            });
          });

      } else if (this.paymentMethod === 'credit_card') {
        const cc = this.creditCard;

        if (
          !cc.name_on_card ||
          !cc.billing_address ||
          !cc.city ||
          !cc.state ||
          !cc.zip ||
          !cc.email ||
          !cc.card_types.length ||
          !cc.card_number ||
          !cc.expiry ||
          !cc.security_code
          || !cc.company_name
          || !cc.location_address
        ) {
          Swal.fire({
            title: "Missing Fields",
            text: "Please fill all required Credit Card fields.",
            icon: "error",
            confirmButtonText: "Ok"
          });
          return;
        }

        this.$http.post("sendMailToAccounts", {
          type: "credit_card",
          data: {
            name_on_card: cc.name_on_card,
            billing_address: cc.billing_address,
            city: cc.city,
            state: cc.state,
            zip: cc.zip,
            email: cc.email,
            card_types: cc.card_types,
            card_number: cc.card_number,
            expiry: cc.expiry,
            security_code: cc.security_code,
            company_name: cc.company_name,
            location_address: cc.location_address
          }
        })
          .then(() => {
            Swal.fire({
              title: "Credit Card Info",
              text: "Submitted successfully.",
              icon: "success",
              confirmButtonText: "Ok"
            });
            this.$router.push('/dashboard');

          })
          .catch(() => {
            Swal.fire({
              title: "Submission Failed",
              text: "Could not send credit card info.",
              icon: "error",
              confirmButtonText: "Ok"
            });
          });
      }
    }
  }
};
</script>
<style>
.logo-size{
  width: 180px !important;
  height: auto;
}
.stripe-card {
  border: 1px solid grey;
}

.stripe-card.complete {
  border-color: green;
}

</style>
